import { BrowserRouter, Link, NavLink, Route, Routes } from "react-router-dom"
import { SpecificationSection } from "./SpecificationSection"
import { ValidatorSection } from "./ValidatorSection"
import { SupportedSoftwareSection } from "./SupportedSoftwareSection"

export function App() {

    // add a header and description of the format
    // a 2 tabs, one for Specification, one for Validator

    return <BrowserRouter>
        <div className="container">
            <div className="header">
                <a href="https://www.playitsoftware.com/" target="_blank">
                    <img src="https://www.playitsoftware.com/Content/Images/playit-logo.svg" alt="PlayIt Software" />
                </a>
            </div>
            <h1>PlayIt Playout Log Format 2.0</h1>
            <p>
                The PlayIt Playout Log Format 2.0 is a format used for importing logs from external music schedulers and merging logs from external commercial traffic schedulers into <a href="https://www.playitsoftware.com/Products/Live" target="_blank">PlayIt Live</a>, the radio playout software from <a href="https://www.playitsoftware.com/" target="_blank">PlayIt Software</a>.
            </p>
            <nav>
                <ul>
                    <li><NavLink to="/">Specification</NavLink></li>
                    <li><NavLink to="/validator" className="">Validator</NavLink></li>
                    <li><NavLink to="/supported-software" className="">Supported Software</NavLink></li>
                </ul>
            </nav>

            <Routes>
                <Route path="/" element={<SpecificationSection />} />   
                <Route path="/validator" element={<ValidatorSection />} />
                <Route path="/supported-software" element={<SupportedSoftwareSection />} />
            </Routes>

            <footer>
                Copyright © PlayIt Software Ltd. All Rights Reserved. Registered Office: 71-75 Shelton Street, London, Greater London, United Kingdom, WC2H 9JQ. Registered in England & Wales. Company Number: 11947269.
            </footer>

        </div>
    </BrowserRouter>
}

